<style>
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

/*.mdi:before,.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}*/

</style>
<template>
  <v-app id="sentinelle">
    <!-- BEGIN MENU LATERAL DROITE -->
    <template v-if="isListObjetRetrieved && isUserAuthenticated">
      <v-navigation-drawer
        v-model="sideBarMenuVisible" :clipped="false"
        :width="sideBarMenuWidth" app
        stateless>
        <v-expansion-panels v-model="panel" :disabled="true" readonly>
          <v-expansion-panel class="ma-0 pa-0">
            <!-- BEGIN LISTE OBJET -->
            <v-expansion-panel-header class="ma-0 pa-1">
              <v-btn block color="primary lighten-1">
                <v-icon dark left>list</v-icon>
                Liste des {{ subject }}s
                <v-badge color="secondary lighten-1" right>
                  <span slot="badge">{{ getNumObjet }}</span>
                  <v-icon color="info lighten-2" large>
                  </v-icon>
                </v-badge>
              </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <DegradationManager
                :objects-geo-json="geojsonData.features"
                class="ma-0 pa-0"
                @managerClickItem="handleClickItem"
                @managerDeleteItem="handleDeleteItem"
                @managerEditItem="handleEditItem"
                @managerShowItem="handleShowItem"
                @managerTerminateItem="handleTerminateItem"
                @managerUnValidateItem="handleUnValidateItem"
                @managerValidateItem="handleValidateItem"
              >
              </DegradationManager>
            </v-expansion-panel-content>
            <!-- END LISTE OBJET -->
            <v-expansion-panel class="ma-0 pa-0">
              <v-expansion-panel-header class="ma-0 pa-1">
                <v-btn block color="primary lighten-1">
                  <v-icon dark left>assignment</v-icon>
                  {{ getTitleForm }}
                  <v-badge v-if="editedItem.properties.id > 0" color="secondary lighten-1" right>
                    <span slot="badge">id:{{ editedItem.properties.id }}</span>
                    <v-icon color="info lighten-2" large>
                    </v-icon>
                  </v-badge>
                </v-btn>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <DegradationForm :currentObject="editedItem"
                                 :read-only="formIsReadOnly"
                                 class="ma-0 pa-0"
                                 @formCancel="cancelForm"
                                 @formSave="saveItem">
                </DegradationForm>
                <template v-if="this.checkAddPhotoPermissions(this.editedItem)">
                  <DocumentUploadForm :currentObject="editedItem"
                                      class="ma-0 pa-0"
                                      @documentExtensionInvalidError="handleDocExtInvalidError"
                                      @documentUploadSave="handleEditItem"
                                      @documentUploadSaveError="handleDocumentPostError"
                                      @formCancel="cancelForm">
                  </DocumentUploadForm>
                </template>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-navigation-drawer>
      <!-- END MENU LATERAL DROITE -->
    </template>
    <v-app-bar app color="primary" dark>
      <v-img
        :alt="`${appName} Logo`"
        :src="require('./assets/logo.png')"
        class="shrink mr-0"
        contain
        height="50"
        transition="scale-transition"
      />
      <template
        v-if="isListObjetRetrieved && isUserAuthenticated
        && !isUserManagerVisible && !isDashboardVisible">
        <v-app-bar-nav-icon @click.stop="sideBarMenuVisible = !sideBarMenuVisible">
          <v-icon>{{ mdiMenu }}</v-icon>
        </v-app-bar-nav-icon>
      </template>
      <v-toolbar-title>{{ appTitle }}</v-toolbar-title> &nbsp;{{ getInfo }}
      <v-spacer></v-spacer>
      <template v-if="isListObjetRetrieved && isUserAuthenticated">
        <template v-if="!isUserHavingLimitedCategories">
          <v-select v-if="!isDashboardVisible"
                    v-model="category_filter"
                    :clearable="true"
                    :items="categories"
                    append-icon="filter_list"
                    class="pa-0"
                    hide-details
                    item-text="name"
                    item-value="id"
                    label="Cliquez pour filtrer avec un type de dégradations existant"
                    menu-props="auto"
                    @change="getObjectList"
          />
          <template v-if="category_filter != null">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="category_filter=null;getObjectList()">
                  <v-icon>clear</v-icon>
                </v-btn>
              </template>
              <span>Cliquez pour supprimer le filtre des dégradations.</span>
            </v-tooltip>
          </template>
        </template>
        <!--<span>.</span>-->
        <template v-if="isUserSectorFiltered">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="toggleSectorFiltering()">
                <v-icon>{{ isSectorFilteringActive ? 'label_off' : 'label' }}</v-icon>
              </v-btn>
            </template>
            <span>Cliquez pour
          {{
                isSectorFilteringActive ?
                  'filtrer uniquement votre secteur' : 'voir tous les secteurs'
              }}
        </span>
          </v-tooltip>
        </template>
        <template v-if="!isUserManagerVisible && !isDashboardVisible">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="getObjectList()">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <span>Cliquez pour actualiser la liste des dégradations.</span>
          </v-tooltip>
        </template>
      </template>
      <template v-if="isUserAdmin">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="toggleUserManager">
              <v-icon>{{ isUserManagerVisible ? 'person_add' : 'person_add_disabled' }}</v-icon>
            </v-btn>
          </template>
          <span>Cliquez pour {{ isUserManagerVisible ? 'cacher' : 'afficher' }}
             le management des utilisateurs !</span>
        </v-tooltip>
      </template>
      <template v-if="isUserManager">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="isDashboardVisible=!isDashboardVisible">
              <v-icon>{{ isDashboardVisible ? 'map' : 'bar_chart' }}</v-icon>
            </v-btn>
          </template>
          <span>Cliquez pour {{ isDashboardVisible ? 'cacher' : 'afficher' }}
             le dashboard avec les statistiques !
            {{ isDashboardVisible ? ' Et revenir à la carte' : '' }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" download icon large>
              <a download href="/dbexport/degradation_export.csv">
                <v-avatar size="32px" tile>
                  <img alt="Liste des dégradations" src="./assets/save2xls.svg">
                </v-avatar>
              </a>
            </v-btn>
          </template>
          <span>Cliquez pour vous récupérer les données au format csv (pour tableurs)!</span>
        </v-tooltip>
      </template>
      <template v-if="isUserAuthenticated">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="logout">
              <v-icon>meeting_room</v-icon>
            </v-btn>
          </template>
          <span>Vous êtes authentifié comme {{ userEmail }},
                        cliquez pour vous déconnecter !</span>
        </v-tooltip>
      </template>
    </v-app-bar>

    <v-content>
      <!--- BEGIN MAIN CONTAINER ABOVE APP TOOLBAR -->
      <v-container class="fill-height" fluid ma-0 pa-0>
        <v-snackbar v-model="alertMessageShow" :color="alertMessageColor"
                    :timeout="alertMessageTimeout" top vertical
        >
          <span class="align-center text-center" v-html="alertMessageText"></span>
          <v-btn color="pink" text @click="alertMessageShow = false">
            Fermer
          </v-btn>
        </v-snackbar>
        <template v-if="isUserAuthenticated">
          <UserManager v-if="isUserAdmin && isUserManagerVisible"/>
          <DashBoard v-if="isUserManager && isDashboardVisible"/>
          <cgil-map v-show="!isUserManagerVisible && !isDashboardVisible"
                    ref="mymap"
                    :center="mapCenter"
                    :extent="mapExtent"
                    :layersconfig="mapLayers"
                    :objects-geojson-data="geojsonData"
                    :zoom="mapZoom"
                    @mapclick="handleMapCLick"
                    @mapisready="setMapReady"
          />
        </template>
        <template v-else>
          <login @loginOK="loginSuccess"/>
        </template>
      </v-container>
      <!--- END MAIN CONTAINER ABOVE APP TOOLBAR -->
    </v-content>
    <!-- pour l'instant on ajoute pas le (+) dans l'interface -->
    <template v-if="isUserAuthenticated && false">
      <v-btn bottom color="secondary" dark fab fixed left @click="dialog = !dialog">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
  </v-app>
</template>

<script>
import { mdiMenu } from '@mdi/js';
import { dateIso2Fr, functionExist, isNullOrUndefined } from 'cgil-html-utils';
import {
  APP,
  BUILD_DATE,
  DEV,
  getLog,
  VERSION, HOME,
} from './config';
import {
  clearSessionStorage,
  doesCurrentSessionExist,
  getTokenStatus,
  getUserEmail, getUserId, getUserName,
  getUserIsAdmin, getUserIsValidator, getUserIsManager,
  getUserIdSecteur, getUserIsAnnouncer, getUserFirstLimitedCategory,
  getUserLimitedCategoriesArray, getUserIdGroup,
} from './components/Login';
import Login from './components/Login.vue';
import UserManager from './components/UserManager.vue';
import DashBoard from './components/DashBoard.vue';
import DegradationManager from './components/DegradationManager.vue';
import DegradationForm from './components/DegradationForm.vue';
import DegradationMixin from './components/Degradation_mixin';
import DocumentUploadForm from './components/DocumentUploadForm.vue';
import cgilMap from './components/cgil-map.vue';
import degradation from './components/Degradation';
import {
  convertEnt, getBoolParam, getIntegerParam, getFloatParam,
} from './utils/utils';
import geo from './components/Geo';
import degradationCategories from './components/DegradationCategories';

const log = getLog(APP, 4, 2);

const positionCathedraleLausanne = [538357.6, 152682.7];

// recuperation parametres dand url
let initialPosition = positionCathedraleLausanne;
const posX = getFloatParam('x', 0);
const posY = getFloatParam('y', 0);
const zoom = getIntegerParam('zoom', 5);
const bb = getBoolParam('bb', false);

const minX = getFloatParam('minx', 531800);
const minY = getFloatParam('miny', 149000);
const maxX = getFloatParam('maxx', 547000);
const maxY = getFloatParam('maxy', 162000);
let extent = null;
if (bb) {
  extent = [minX, minY, maxX, maxY];
}
if (posX !== 0 && posY !== 0) {
  initialPosition = [posX, posY];
}
const myOnCloseHandlerwindow = (e) => {
  log.w('# IN EVENT beforeunload ');
  // bon ben les nouveaux navigateurs en ont rien a foutre du message...
  const confirmationMessage = 'Voulez vous vraiment quitter cette page ?';
  (e || window.event).returnValue = confirmationMessage; // Gecko + IE
  return confirmationMessage; // Webkit, Safari, Chrome
};

export default {
  name: 'App',

  components: {
    Login,
    UserManager,
    DashBoard,
    DegradationManager,
    DegradationForm,
    DocumentUploadForm,
    cgilMap,
  },

  mixins: [DegradationMixin],

  data: () => ({
    appName: APP,
    appTitle: `${APP} - ${VERSION}`,
    closeHandlerActive: false,
    alertMessageShow: false,
    alertMessageText: 'Rien à signaler',
    alertMessageTimeout: 7000, // 7 sec par defaut
    alertMessageColor: 'success',
    isInDev: DEV,
    isUserAuthenticated: false,
    userEmail: '',
    isUserAdmin: false,
    isUserValidator: false,
    isUserManager: false,
    isUserAnnouncer: false,
    isUserHavingLimitedCategories: false,
    userLimitedCategories: null,
    idUser: null,
    idUserGroup: null,
    idUserSector: null,
    isUserSectorFiltered: false,
    isSectorFilteringActive: false,
    isUserManagerVisible: false,
    isDashboardVisible: false,
    autoLogoutTimer: null,
    dialog: false,
    sideBarMenuVisible: false,
    isListObjetRetrieved: false,
    formIsReadOnly: false,
    panel: 0, // 0-list, 1-form
    isInEditMode: false,
    categories: [],
    category_filter: null,
    isCategoriesRetrievied: false,
    mapZoom: zoom,
    mapCenter: initialPosition,
    mapExtent: extent,
    mapLayers: {
      baseLayer: 'fonds_geo_osm_bdcad_couleur',
      layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout',
      wmsLayers: [
        {
          layers: '',
          title: '',
          isVisible: false,
        },
      ],
    }, // FIN DE LA CONFIG DES mapLayers
    geojsonData: null,
    mapIsReady: false,
    mapNeedsLoadingData: false,
    mdiMenu,
  }),
  computed: {
    getInfo() {
      if (this.isInDev) {
        // https://vuetifyjs.com/en/customization/breakpoints/
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return `${this.$vuetify.breakpoint.name} <600px`;
          case 'sm':
            return `${this.$vuetify.breakpoint.name} 600px > < 960px`;
          case 'md':
            return `${this.$vuetify.breakpoint.name} 960px > < 1264px*`;
          case 'lg':
            return `${this.$vuetify.breakpoint.name} 1264px* > < 1904px*`;
          case 'xl':
            return `${this.$vuetify.breakpoint.name} > 1904px*`;
          default:
            return `?? ${this.$vuetify.breakpoint.name} ??`;
        }
      }
      return '';
    },
    getTitleForm() {
      if (this.editedItem.properties.id > 0) {
        if (this.formIsReadOnly) {
          return 'Consultation Annonce';
        }
        return 'Edition Annonce';
      }
      if (this.isInEditMode) {
        return 'Nouvelle Annonce';
      }
      return '';
    },
    getNumObjet() {
      if (isNullOrUndefined(this.geojsonData)) return -1;
      if (isNullOrUndefined(this.geojsonData.features)) return -1;
      return this.geojsonData.features.length;
    },
    sideBarMenuWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 330; // small to large handset    < 600px
        case 'sm':
          return 406; // small to medium tablet     600px > < 960px
        case 'md':
          return 500; // large tablet to laptop     960px > < 1264*
        case 'lg':
          return 650; // desktop                   1264px > < 1904px*
        case 'xl':
          return 850; // 4k and ultra-wides              > 1904px*
        default:
          return 330;
      }
    },
  },
  filters: {
    convertTextEnt(text) {
      return convertEnt(text);
    },
    timestampDateIso2Europe(isoDate) {
      if (isNullOrUndefined(isoDate)) return '';
      return dateIso2Fr(isoDate.split('T')[0]);
    },
    limitTextSize(text, maxSize = 100) {
      if (isNullOrUndefined(text)) return '';
      if (text.length < maxSize) return text;
      return `${text.substring(0, maxSize)}…`;
    },
  },
  mounted() {
    log.t(`# IN ${APP} mounted()`);
    log.w(`${APP} - ${VERSION}, du ${BUILD_DATE}`);
    log.l(`pos:[${posX}, ${posY}] zoom: ${zoom}`);
    // uncomment next line to force a new login at each mount
    //  this.resetInitialState();
    // network disconnection handlers
    window.addEventListener('online', () => {
      log.w('ONLINE AGAIN :)');
      this.showMessage('⚡⚡🚀  YES! LE RESEAU EST REVENU 🚀⚡⚡ <br> 😊 A PRIORI VOUS ETES A NOUVEAU "ONLINE"  ', 'success');
    });
    window.addEventListener('offline', () => {
      log.w('OFFLINE :((');
      this.showMessage('⚡⚡⚠ PAS DE RESEAU ! ⚠ ⚡⚡ <br> ☹ VOUS ETES "OFFLINE" ', 'error');
    });

    this.checkIsSessionTokenValid();
  }, // end of mounted
  methods: {
    showMessage(msgText, msgType = 'info') {
      this.alertMessageColor = msgType;
      this.alertMessageText = msgText;
      if (msgType === 'error') {
        this.alertMessageTimeout = 30000;
      } else {
        this.alertMessageTimeout = 7000;
      }
      this.alertMessageShow = true;
    },
    checkEditPermissions(item) {
      if (item.properties.id === 0) {
        return true; // cas d'un nouvel enregistrement
      }
      if (this.isUserHavingLimitedCategories) {
        // SI OBJET CID ET QUE USER CID ON MONTRE UNIQUEMENT CAR PAS EDITION
        if (this.userLimitedCategories.indexOf(item.properties.idcategorie) > -1) {
          return false;
        }
      }
      if (item.properties.isvalidated === null) {
        if (this.idUser === item.properties.creator || this.isUserAdmin || this.isUserValidator) {
          return true;
        }
      }
      return false;
    },
    checkAddPhotoPermissions(item) {
      if (item.properties.id === 0) {
        return false; // cas d'un nouvel enregistrement
      }
      if (item.properties.isvalidated === null) {
        if (this.idUser === item.properties.creator) {
          return true;
        }
      }
      return false;
    },
    toggleForm() {
      log.t('# IN toggleForm()');
      if (!this.sideBarMenuVisible) this.sideBarMenuVisible = true;
      this.formIsReadOnly = !this.checkEditPermissions(this.editedItem);
      this.isInEditMode = true;
      this.panel = 1;
    },
    toggleList() {
      log.t('# IN toggleList()');
      if (!this.sideBarMenuVisible) this.sideBarMenuVisible = true;
      this.isInEditMode = false;
      this.panel = 0;
    },
    toggleSectorFiltering() {
      log.t('# IN toggleSectorFiltering()');
      if (this.isUserSectorFiltered) {
        if (this.isSectorFilteringActive) {
          this.idUserSector = getUserIdSecteur();
        } else {
          this.idUserSector = 0;
        }
        this.isSectorFilteringActive = !this.isSectorFilteringActive;
      }
      log.l(`# IN toggleSectorFiltering() this.idUserSector=${this.idUserSector}`);
      this.getExistingCategories();
      setTimeout(this.getObjectList, 500);
    },
    loginSuccess() {
      log.t('# IN loginSuccess()');
      this.isUserAuthenticated = true;
      this.userEmail = getUserEmail();
      this.isUserAdmin = getUserIsAdmin();
      this.isUserValidator = getUserIsValidator();
      this.isUserManager = getUserIsManager();
      this.isUserAnnouncer = getUserIsAnnouncer();
      this.idUserGroup = getUserIdGroup();
      if (!isNullOrUndefined(getUserFirstLimitedCategory())) {
        this.isUserHavingLimitedCategories = true;
        this.userLimitedCategories = getUserLimitedCategoriesArray();
      } else {
        this.isUserHavingLimitedCategories = false;
      }
      this.idUser = getUserId();
      this.idUserSector = getUserIdSecteur();
      if (this.idUserSector !== 0) {
        this.isUserSectorFiltered = true;
      }
      if (!this.closeHandlerActive && !this.isInDev) {
        window.addEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = true;
      }
      this.getExistingCategories();
      setTimeout(this.getObjectList, 1000);
      if (isNullOrUndefined(this.autoLogoutTimer)) {
        // check every 60 seconds(60'000 milliseconds) if jwt is still valid
        this.autoLogoutTimer = setInterval(this.checkIsSessionTokenValid, 60000);
      }
    },
    logout() {
      log.t('# IN logout()');
      this.resetInitialState();
      // logoutAndResetToken(DEFAULT_BASE_SERVER_URL);
      this.showMessage(
        'Vous vous êtes déconnecté de l\'application avec succès !',
      );
      if (this.closeHandlerActive) {
        window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = false;
      }
      setTimeout(() => {
        window.location.href = HOME;
      }, 2000); // after 2 sec redirect to home page just in case
    },
    getExistingCategories() {
      degradationCategories.getExistingCategorieList(this.idUserSector, (data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // on traite le tableau pour ajouter le nombre d'occurences au label
          this.categories = data.map((c) => {
            const e = { ...c };
            e.name = `${c.name} (${c.num})`;
            return e;
          });
          log.l('# IN getExistingCategories -> categories :', this.categories);
          this.isCategoriesRetrievied = true;
        } else {
          log.e(
            `# GOT ERROR IN getExistingCategories() in callback for degradationCategories.degradationCategories data: ${errMessage}`,
          );
          this.isCategoriesRetrievied = false;
        }
      });
    },
    getObjectList(callbackListLoaded) {
      log.t('# IN getObjectList() before call object.getList()', this.geojsonData);
      // log.w(`isUserHavingLimitedCategories : ${this.isUserHavingLimitedCategories}`);
      if (isNullOrUndefined(this.category_filter)) {
        degradation.getList(this.idUserSector, (data, errMessage) => {
          if (!isNullOrUndefined(data)) {
            // traiter correctement le cas d'une absence de dégradatation (cas des RTMO)
            if (isNullOrUndefined(data.features)) {
              const msgToDisplay = `Bonjour ${getUserName()},<br>
                    Pour l'instant, il n'y a aucune annonces de dégradations vous concernant !`;
              this.showMessage(msgToDisplay, 'warning');
              this.isListObjetRetrieved = false;
            } else {
              this.geojsonData = data;
              log.l('# IN initialize -> objet data :', this.geojsonData);
              if (this.mapIsReady) {
                this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
              } else {
                this.mapNeedsLoadingData = true;
              }
              this.isListObjetRetrieved = true;
              if (functionExist(callbackListLoaded)) {
                callbackListLoaded(data, 'SUCCESS');
              }
            }
          } else {
            log.e(
              `# GOT ERROR IN initialize() in callback for degradation.getList data: ${errMessage}`,
            );
            this.isListObjetRetrieved = false;
            this.showMessage('Impossible de récupérer les annonces de dégradations !', 'error');
            if (functionExist(callbackListLoaded)) callbackListLoaded(null, errMessage);
          }
        });
      } else {
        log.l(`# let's get  a filtered list for category : ${this.category_filter} `);
        if (this.isInEditMode && !this.formIsReadOnly) {
          log.w(`DEMANDE FILTRAGE MAIS EN COURS D EDITION ID ${this.editedItem.properties.id}`);
          if (this.editedItem.properties.idcategorie !== this.category_filter) {
            this.showMessage("VEUILLEZ TERMINER L'EDITION EN COURS AVANT DE FILTER", 'warning');
            this.category_filter = null;
            return;
          }
        }
        degradation.getListFiltered(this.category_filter, this.idUserSector, (data, errMessage) => {
          if (!isNullOrUndefined(data)) {
            if (!isNullOrUndefined(data.features)) {
              this.geojsonData = data;
              log.l('# IN getListFiltered -> objet data :', this.geojsonData);
              if (this.mapIsReady) {
                this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
              } else {
                this.mapNeedsLoadingData = true;
              }
              this.isListObjetRetrieved = true;
              if (functionExist(callbackListLoaded)) {
                callbackListLoaded(data, 'SUCCESS');
              }
            } else {
              this.showMessage('Il n\'y pas d\'annonces de dégradations pour cette catéorie !', 'error');
              this.category_filter = null;
            }
          } else {
            log.e(
              `# GOT ERROR IN initialize() in callback for degradation.getList data: ${errMessage}`,
            );
            this.isListObjetRetrieved = false;
            this.showMessage('Impossible de récupérer les annonces de dégradations !', 'error');
            if (functionExist(callbackListLoaded)) callbackListLoaded(null, errMessage);
          }
        });
      }
    },
    resetInitialState() {
      log.t('# IN resetInitialState()');
      if (this.closeHandlerActive) {
        window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
        this.closeHandlerActive = false;
      }
      this.closeHandlerActive = false;
      this.alertMessageShow = false;
      this.alertMessageText = 'Rien à signaler';
      this.alertMessageTimeout = 7000; // 7 sec par defaut
      this.alertMessageColor = 'success';
      this.isUserAuthenticated = false;
      this.userEmail = '';
      this.isUserAdmin = false;
      this.isUserValidator = false;
      this.isUserManager = false;
      this.isUserAnnouncer = false;
      this.isUserHavingLimitedCategories = false;
      this.userLimitedCategories = null;
      this.idUser = null;
      this.idUserSector = null;
      this.idUserGroup = null;
      this.isUserSectorFiltered = false;
      this.isSectorFilteringActive = false;
      this.category_filter = null;
      this.categories = [];
      this.isCategoriesRetrievied = false;
      this.isListObjetRetrieved = false;
      this.geojsonData = null;
      this.isInEditMode = false;
      this.isUserManagerVisible = false;
      this.isDashboardVisible = false;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
      clearSessionStorage();
      clearInterval(this.autoLogoutTimer);
    },
    checkIsSessionTokenValid() {
      log.t('# IN checkIsSessionTokenValid()');
      if (doesCurrentSessionExist()) {
        getTokenStatus(this.base_server_url)
          .then((res) => {
            log.t('# IN checkIsSessionTokenValid() getTokenStatus.then success res: ', res);
            if (isNullOrUndefined(res.id)) {
              log.w('getTokenStatus DID NOT GET res.id I will now RESET TO INITIAL: ', res);
              this.resetInitialState();
              if (this.closeHandlerActive) {
                window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
                this.closeHandlerActive = false;
              }
              if ((res.indexOf('code 401') > 0) && (res.indexOf('Error:') > -1)) {
                log.w('getTokenStatus 401 detected redirecting to home page byebye! ');
                setTimeout(() => { // end of story get back to home and login
                  window.location.href = HOME;
                }, 500); // after 500 milisec redirect to home page just in case
              }
            } else {
              // okay login successful
              this.isUserAuthenticated = true;
              this.userEmail = getUserEmail();
              this.isUserAdmin = getUserIsAdmin();
              this.isUserValidator = getUserIsValidator();
              this.isUserManager = getUserIsManager();
              this.isUserAnnouncer = getUserIsAnnouncer();
              if (!isNullOrUndefined(getUserFirstLimitedCategory())) {
                this.isUserHavingLimitedCategories = true;
                this.userLimitedCategories = getUserLimitedCategoriesArray();
              } else {
                this.isUserHavingLimitedCategories = false;
              }
              this.idUser = getUserId();
              this.idUserSector = getUserIdSecteur();
              this.idUserGroup = getUserIdGroup();
              if (this.idUserSector !== 0) {
                this.isUserSectorFiltered = true;
              }
              log.l('# IN checkIsSessionTokenValid() before this.getExistingCategories()');
              this.getExistingCategories();
              if (!this.closeHandlerActive && !this.isInDev) {
                window.addEventListener('beforeunload', myOnCloseHandlerwindow, false);
                this.closeHandlerActive = true;
              }
              log.l(`# IN checkIsSessionTokenValid() getTokenStatus idUser : ${this.idUser}`);
              if (isNullOrUndefined(this.geojsonData)) {
                log.w('# about to call getObjectList');
                this.getObjectList(); // retrieve objects
              }
              if (isNullOrUndefined(this.autoLogoutTimer)) {
                // check every 60 seconds(60'000 milliseconds) if jwt is still valid
                this.autoLogoutTimer = setInterval(this.checkIsSessionTokenValid, 60000);
              }
            }
          })
          .catch((err) => {
            log.w('# IN checkIsSessionTokenValid() getTokenStatus.catch catch ERROR : ', err);
            this.resetInitialState();
            this.showMessage(
              '### VOTRE SESSION A EXPIRE !<br>VEUILLEZ SVP VOUS RECONNECTER.',
              'error',
            );
            if (this.closeHandlerActive) {
              window.removeEventListener('beforeunload', myOnCloseHandlerwindow, false);
              this.closeHandlerActive = false;
            }
            setTimeout(() => {
              window.location.href = HOME;
            }, 500); // after 500 milisec redirect to home page just in case
          });
      } else {
        log.w('SESSION DOES NOT EXIST OR HAS EXPIRED !');
        this.resetInitialState();
      }
    },
    getObjetItembyId(id) {
      if (isNullOrUndefined(this.geojsonData)
        || isNullOrUndefined(this.geojsonData.features)) {
        return null;
      }
      for (let i = 0; i < this.geojsonData.features.length; i += 1) {
        const currentItem = this.geojsonData.features[i];
        if (currentItem.properties.id === id) return currentItem;
      }
      return null;
    },

    updateTitleByNewPosition(newPos) {
      if ((!isNullOrUndefined(newPos)) && (!isNullOrUndefined(newPos[0]))) {
        this.editedItem.geometry.coordinates = newPos;
        [this.editedItem.properties.x, this.editedItem.properties.y] = newPos;
        this.editedItem.properties.geom_wkt = `POINT(${newPos[0]} ${newPos[1]})`;
        geo.findAddressNameByPoint(this.editedItem.properties.x,
          this.editedItem.properties.y,
          (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in handleNewItem callback for geo.findAddressNameByPoint call retval', retval);
              const newAddress = retval.name;
              // check if categories is present :
              if (this.editedItem.properties.title.indexOf(', ') > 1) {
                const strCategorie = this.editedItem.properties.title.split(', ')[1];
                // eslint-disable-next-line no-irregular-whitespace
                this.editedItem.properties.title = `${newAddress}, ${strCategorie}`;
              } else {
                this.editedItem.properties.title = newAddress;
              }
            } else {
              log.e(`# ERROR in handleNewItem callback for geo.findAddressNameByPoint call
            ERROR : ${errorMsg}
            val`, retval);
              this.showMessage(`ERREUR pendant la récupération de cet enregistrement !
              ${errorMsg}`, 'error');
            }
          });
      }
    },

    handleMapCLick(info) {
      log.t('#### In handleMapCLick cgil-vue-olmap event mapclick received : ', info);
      if (!isNullOrUndefined(info.features) && info.features[0].layer !== 'secteurs') {
        log.l('#### In handleMapCLick info.features found', info.features[0]);
        if (!isNullOrUndefined(info.features[0])) {
          const data = info.features[0];
          if (!isNullOrUndefined(data.layer)) {
            if (data.layer === 'gobjects_points_of_interest') {
              // GOOD PLACE TO CHECK IF FEATURE IS OBJET THEN SHOW(item)
              const realItem = this.getObjetItembyId(info.features[0].data.id);
              if (this.isInEditMode && !this.formIsReadOnly) {
                log.w(
                  `--TROUVE OBJET dans gobjects_points_of_interest
                  id [${info.features[0].data.id}]
                  MAIS EN COURS D EDITION DONC ON FAIT RIEN`,
                );
                // ca sert a rien de gueuler si le gars clique sur l'objet en cours d'edition
                if (info.features[0].data.id !== this.editedItem.properties.id) {
                  // eslint-disable-next-line
                  if (confirm('êtes-vous sûr de vouloir abandonner l\'édition qui en cours ?')) {
                    this.handleShowItem(realItem);
                    this.$refs.mymap.clearNewMarker();
                  }
                }
              } else {
                if (realItem.properties.isvalidated) {
                  log.l('#### In handleMapCLick item already validated so show it');
                  this.handleShowItem(realItem);
                }
                log.l('#### In handleMapCLick Object found :', realItem);
                // SI OBJET CID ET QUE USER CID ON MONTRE UNIQUEMENT CAR PAS EDITION
                log.w(`userLimitedCategories:${this.userLimitedCategories}`,
                  realItem.properties.idcategorie);
                if (!isNullOrUndefined(this.userLimitedCategories)) {
                  if (this.userLimitedCategories.indexOf(realItem.properties.idcategorie) > -1) {
                    this.handleShowItem(realItem);
                  }
                }
                if (this.idUser === realItem.properties.creator
                  || this.isUserAdmin || this.isUserValidator) {
                  this.handleEditItem(realItem);
                } else {
                  this.handleShowItem(realItem);
                }
              }
            } // FIN DU TRAITEMENT CLIK SUR gobjects_points_of_interest
          }
        }
      } else if (this.isInEditMode && !this.formIsReadOnly) {
        log.l(`geom_wkt : ${this.editedItem.properties.geom_wkt}`);
        if (isNullOrUndefined(this.editedItem.properties.geom_wkt)
          || this.editedItem.properties.id === 0) {
          log.w('-- EN COURS CREATION NEW  MAIS PAS ENCORE DE GEOM => UPDATE POS ');
          // eslint-disable-next-line
          if (confirm('êtes-vous sûr de modifier la position du nouvel objet ici ?')) {
            this.$refs.mymap.clearNewMarker();
            this.$refs.mymap.centerMap(info.coordinates);
            this.editedItem.geometry.coordinates = info.coordinates;
            [this.editedItem.properties.x, this.editedItem.properties.y] = info.coordinates;
            this.editedItem.properties.geom_wkt = `POINT(${info.coordinates[0]} ${info.coordinates[1]} )`;
            this.$refs.mymap.addNewMarker(info.coordinates, 'Nouvel Objet');
            this.updateTitleByNewPosition(info.coordinates);
          } else {
            log.w('USER CHOOSED TO NOT UPDATE POS !');
          }
        } else {
          log.w('-- DEJA EN COURS D EDITION DONC UPDATE POS OBJET EN COURS');
          const currentProp = this.editedItem.properties;
          const objectId = currentProp.id;
          // SAVING MODIFICATIONS TO EXISTING OBJECT
          const old = this.geojsonData.features.find((x) => x.properties.id === currentProp.id);
          const i = this.geojsonData.features.indexOf(old);
          // eslint-disable-next-line
          if (confirm('êtes-vous sûr de modifier la position de cet objet ici ?')) {
            log.w(`# GEOM EDITING  for id:${objectId} index : ${i}`, i);
            this.geojsonData.features[i].geometry.coordinates = info.coordinates;
            this.$refs.mymap.centerMap(info.coordinates);
            this.editedItem.geometry.coordinates = info.coordinates;
            [this.editedItem.properties.x, this.editedItem.properties.y] = info.coordinates;
            this.editedItem.properties.geom_wkt = `POINT(${info.coordinates[0]} ${info.coordinates[1]} )`;
            this.$refs.mymap.clearNewMarker();
            this.updateTitleByNewPosition(info.coordinates);
            // this.$refs.mymap.addNewMarker(info.coordinates, 'Nouvel Objet');
            this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
          } else {
            log.w('USER CHOOSED TO NOT UPDATE POS OF EDITED OBJECT !');
          }
        }
      } else {
        log.w('-- PAS EN COURS D EDITION DONC NEW');
        // SI USER CID OU RM ON SORT CAR PAS DE NEW SI PAS DE VISIBILITE EXISTANT
        // si C'EST GROUP  12 ==> POLICE ALORS ON DOIT LAISSER SAISIR JUSTE TAG
        // PUTAIN DE BORDEL CES DEMANDES DE MODIFS ET D?EXCEPTION C?EST DE LA DAUBE DE VDL A LA CON
        if ((!this.isUserHavingLimitedCategories)
          || (this.idUserGroup === 12 || this.idUserGroup === 13)) {
          const tempFeature = this.$refs.mymap.addNewMarker(
            info.coordinates, 'Nouvel Objet',
          );
          log.w('tempFeature', tempFeature);
          // eslint-disable-next-line
          if (confirm('êtes-vous sûr de vouloir saisir un nouvel objet ici ?')) {
            // on prepare pour un eventuel new Item
            this.formIsReadOnly = false;
            this.isInEditMode = false;
            this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
            // this.objetEditedIndex = -1;
            this.editedIndex = -1;
            if (this.idUserGroup === 12 || this.idUserGroup === 13) {
              this.editedItem.properties.idcategorie = 1; // si on est avec police c'est que du tag
              this.editedItem.properties.categorie = 'Tags';
            }
            // this.objetEdit.geom_wkt = `POINT(${info.coordinates[0]} ${info.coordinates[1]} )`;
            this.handleNewItem(info.coordinates);
            this.$refs.mymap.centerMap(info.coordinates);
            this.toggleForm();
          } else {
            this.$refs.mymap.clearNewMarker();
          }
        } else {
          this.showMessage('VOTRE PROFIL NE PERMET PAS DE CREER DES DEGRADATIONS', 'warning');
        }
      }
      log.t('#### END OF handleMapCLick');
    },
    handleClickItem(item) {
      log.t('# in handleClickItem', item);
      if (!isNullOrUndefined(item)) {
        if (!isNullOrUndefined(item.properties)) {
          if (!isNullOrUndefined(item.properties.x)) {
            this.$refs.mymap.gotoNewPos([item.properties.x, item.properties.y]);
          }
        }
      }
    },
    handleDocumentPostError(ErrorInfo, item) {
      log.w('ERROR received in handleDocumentPostError', ErrorInfo);
      if (ErrorInfo.indexOf('go_document_unique_md5sum') > 0) {
        this.showMessage(`ERREUR : <strong> CE DOCUMENT EXISTE DEJA DANS LA BD !!!</strong></br>
         <i>VOUS NE POUVEZ PAS RENVOYER UN DOCUMENT QUI EXISTE DEJA DANS LA BASE DE DONNEES</i> <br>
        ${ErrorInfo}`, 'error');
      } else {
        this.showMessage(ErrorInfo, 'error');
      }
      this.handleEditItem(item);
    },
    handleDocExtInvalidError(ErrorInfo, item) {
      log.w('ERROR received in handleDocExtInvalidError', ErrorInfo);
      this.showMessage(`ERREUR : <strong> CETTE EXTENSION DE DOCUMENT N'EST PAS AUTORISEE !</strong></br>
         <i>VOUS NE POUVEZ ENVOYER QUE DES IMAGES DE TYPE JPG ou PNG</i> <br>
        ${ErrorInfo}`, 'error');
      this.handleEditItem(item);
    },
    handleEditItem(item, idToEdit = null) {
      log.t(`# in handleEditItem item:${item}, idToEdit: ${idToEdit}`, item);
      if (!isNullOrUndefined(item)) {
        this.getObjectList((data) => {
          if (isNullOrUndefined(data)) {
            // probleme reseau
            this.showMessage('Impossible d\'éditer cette annonce pour l\'instant (peut-être un problème réseau ?!)', 'warning');
          } else if (item.properties.isvalidated === null) {
            if (this.idUser === item.properties.creator
              || this.isUserAdmin || this.isUserValidator) {
              this.editedIndex = this.geojsonData.features.indexOf(item);
              this.editedItem = JSON.parse(JSON.stringify(item));
              this.$refs.mymap.centerMap(
                [this.editedItem.properties.x, this.editedItem.properties.y],
              );
              this.toggleForm();
            } else {
              this.showMessage('Vous n\'êtes pas autorisé à éditer cette annonce', 'warning');
            }
          } else {
            this.handleShowItem(item);
          }
        });
      } else if (!isNullOrUndefined(idToEdit)) {
        log.l(`# in handleEditItem WILL PREPARE idToEdit: ${idToEdit} `);
        this.getObjectList((data) => {
          if (isNullOrUndefined(data)) {
            // probleme reseau
            this.showMessage('Impossible d\'éditer cette annonce pour l\'instant (peut-être un problème réseau ?!)', 'warning');
          } else {
            const newItem = this.getObjetItembyId(idToEdit);
            // TODO Check pourquoi a la creation newItem est null ???
            log.l(`# in handleEditItem WILL PREPARE idToEdit: ${idToEdit} item found:`, newItem);
            if (newItem.properties.isvalidated === null
              && !isNullOrUndefined(newItem)
            ) {
              if (this.idUser === newItem.properties.creator
                || this.isUserAdmin || this.isUserValidator) {
                this.editedIndex = this.geojsonData.features.indexOf(newItem);
                this.editedItem = JSON.parse(JSON.stringify(newItem));
                this.$refs.mymap.centerMap(
                  [this.editedItem.properties.x, this.editedItem.properties.y],
                );
                this.toggleForm();
              } else {
                this.showMessage('Vous n\'êtes pas autorisé à éditer cette annonce', 'warning');
              }
            } else {
              this.handleShowItem(item);
            }
          }
        });
      }
    },
    handleShowItem(item) {
      log.t('# in handleShowItem', item);
      this.editedIndex = this.geojsonData.features.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.formIsReadOnly = true;
      this.$refs.mymap.centerMap([this.editedItem.properties.x, this.editedItem.properties.y]);
      this.toggleForm();
      /* degradation.get(item.id, (retval, errorMsg) => {
                    if (errorMsg === 'SUCCESS') {
                      log.w('# in editItem callback for degradation.get call val', retval);
                      this.editedItem = JSON.parse(JSON.stringify(retval));
                    } else {
                      log.e(
                        `# ERROR in editItem callback for degradation.get call
                        ERROR : ${errorMsg}
                        val`,
                        retval,
                      );
                      this.showMessage(
                        `ERREUR pendant la récupération de cet enregistrement !
                          ${errorMsg}`,
                        'error',
                      );
                    }
                  }); */
    },
    handleDeleteItem(item) {
      log.t('# in handleDeleteItem', item);
      const index = this.geojsonData.features.indexOf(item);
      const rx = /\[(.+)\]/gm;
      const { id } = this.geojsonData.features[index].properties;
      // eslint-disable-next-line
      if (confirm(`Etes vous sur de vouloir effacer l\`enregistrement id:${id}? `)) {
        degradation.delete(id, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w('# in handleDeleteItem callback for degradation.delete call val', retval);
            const idDeleted = rx.exec(retval.message)[1];
            this.showMessage(`L\`enregistrement id: ${idDeleted}, a été effacé avec succès de la BD `, 'success');
            log.w(`# in saveDialog for existing item id ${retval}`);
            this.geojsonData.features.splice(index, 1);
            this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
            this.getObjectList();
          } else {
            log.e(
              `# ERROR in handleDeleteItem callback for degradation.delete call
            ERROR : ${errorMsg}
            val`,
              retval,
            );
            this.showMessage(
              `ERREUR pendant l\`effacement de cet enregistrement !
              ${errorMsg}`,
              'error',
            );
          }
        });
      }
    },
    handleValidateItem(item) {
      log.t('# in handleValidateItem', item);
      const index = this.geojsonData.features.indexOf(item);
      const rx = /\[(.+)\]/gm;
      const { id } = this.geojsonData.features[index].properties;
      // eslint-disable-next-line
      if (confirm(`Etes vous sur de vouloir valider l\`annonce id:${id}? `)) {
        degradation.validate(id, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w('# in handleValidateItem callback for degradation.validate call val', retval);
            const idDeleted = rx.exec(retval.message)[1];
            this.geojsonData.features[index].properties.isvalidated = true;
            this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
            this.cancelForm();
            this.showMessage(`L\`annonce id: ${idDeleted}, a été validée avec succès de la BD `, 'success');
          } else {
            log.e(
              `# ERROR in handleValidateItem callback for degradation.delete call
            ERROR : ${errorMsg}
            val`,
              retval,
            );
            this.showMessage(
              `ERREUR pendant l\`enregistrement de la validation de cette annonce  !
              ${errorMsg}`,
              'error',
            );
          }
        });
      }
    },
    handleUnValidateItem(item) {
      log.t('# in handleValidateItem', item);
      const index = this.geojsonData.features.indexOf(item);
      const rx = /\[(.+)\]/gm;
      const { id } = this.geojsonData.features[index].properties;
      // eslint-disable-next-line
      if (confirm(`Etes vous sur de vouloir REFUSER la validation de l\`annonce id:${id}? `)) {
        degradation.unvalidate(id, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w('# in handleUnValidateItem callback for degradation.validate call val', retval);
            const idDeleted = rx.exec(retval.message)[1];
            this.geojsonData.features.splice(index, 1);
            this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
            this.cancelForm();
            this.showMessage(`L\`annonce id: ${idDeleted}, a été refusée (PAS VALIDE) avec succès de la BD `, 'success');
          } else {
            log.e(
              `# ERROR in handleUnValidateItem callback for degradation.delete call
            ERROR : ${errorMsg}
            val`,
              retval,
            );
            this.showMessage(
              `ERREUR pendant l\`enregistrement de la validation de cette annonce  !
              ${errorMsg}`,
              'error',
            );
          }
        });
      }
    },
    handleTerminateItem(item) {
      log.t('# in handleTerminateItem', item);
      const index = this.geojsonData.features.indexOf(item);
      const rx = /\[(.+)\]/gm;
      const { id } = this.geojsonData.features[index].properties;
      // eslint-disable-next-line
      if (confirm(`Etes vous sur de vouloir terminer l\`annonce id:${id}? `)) {
        degradation.terminate(id, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w('# in handleTerminateItem callback for degradation.validate call val', retval);
            const idDeleted = rx.exec(retval.message)[1];
            this.geojsonData.features[index].properties.isterminated = true;
            this.getObjectList();
            this.cancelForm();
            this.showMessage(`L\`annonce id: ${idDeleted}, a été terminée avec succès de la BD `, 'success');
          } else {
            log.e(
              `# ERROR in handleTerminateItem callback for degradation.delete call
            ERROR : ${errorMsg}
            val`,
              retval,
            );
            this.showMessage(
              `ERREUR pendant l\`enregistrement de la fin de cette annonce  !
              ${errorMsg}`,
              'error',
            );
          }
        });
      }
    },
    cancelForm() {
      log.t('# IN cancelForm()');
      this.$refs.mymap.clearNewMarker();
      setTimeout(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      }, 300);
      this.formIsReadOnly = false;
      this.toggleList();
    },
    handleNewItem(newPos = null) {
      log.t('# in handleNewItem');
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      if ((!isNullOrUndefined(newPos)) && (!isNullOrUndefined(newPos[0]))) {
        this.editedItem.geometry.coordinates = newPos;
        [this.editedItem.properties.x, this.editedItem.properties.y] = newPos;
        this.editedItem.properties.geom_wkt = `POINT(${newPos[0]} ${newPos[1]})`;
        geo.findAddressNameByPoint(this.editedItem.properties.x,
          this.editedItem.properties.y,
          (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in handleNewItem callback for geo.findAddressNameByPoint call retval', retval);
              this.editedItem.properties.title = retval.name;
              if (this.idUserGroup === 12 || this.idUserGroup === 13) {
                this.editedItem.properties.idcategorie = 1; // si c'est user police c'est un tag
                this.editedItem.properties.categorie = 'Tags';
                // eslint-disable-next-line no-irregular-whitespace
                this.editedItem.properties.title = `${this.editedItem.properties.title}, Tags`;
                this.editedItem.properties.icon_src = 'tag';
              }
            } else {
              log.e(`# ERROR in handleNewItem callback for geo.findAddressNameByPoint call
            ERROR : ${errorMsg}
            val`, retval);
              this.showMessage(`ERREUR pendant la récupération de cet enregistrement !
              ${errorMsg}`, 'error');
            }
          });
      }
      // this.editedItem.properties.datecreated = new Date();
      this.editedIndex = -1;
      this.toggleForm();
    },
    saveItem(item) {
      log.t('# in saveItem item', item);
      if (!isNullOrUndefined(item)) {
        const objectId = item.properties.id;
        if (objectId > 0) {
          // SAVING MODIFICATIONS TO EXISTING OBJECT
          log.w(`# in saveItem, EDITING  for id:${objectId}`);
          const temp = JSON.parse(JSON.stringify(item));
          if (!isNullOrUndefined(temp.properties.datecreated)) delete temp.properties.datecreated;
          if (!isNullOrUndefined(temp.properties.datelastmodif)) {
            delete temp.properties.datelastmodif;
          }
          const DegradationUpdate = {
            id: temp.properties.id,
            title: temp.properties.title,
            idcategorie: temp.properties.idcategorie,
            isurgent: temp.properties.isurgent,
            comment: temp.properties.comment,
            lastmodificator: temp.properties.lastmodificator,
            x: temp.properties.x,
            y: temp.properties.y,
          };
          degradation.modify(DegradationUpdate, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in saveDialog callback for degradation.modify call val', retval);
              // retval is the new index
              this.showMessage(
                `Les données ont été sauvée dans la Base id ${retval.id}`,
                'success',
              );
              if (this.category_filter !== temp.properties.idcategorie) {
                // si l'utilisateur a un filtre actif different du nouvel objet
                // on reset le filtre pour eviter qu'il ne comprennent
                // pas pourquoi son objet ne s'affiche pas
                this.category_filter = null;
              }
              log.w(`# in saveDialog for existing item id ${retval}`);
              this.getObjectList();
              this.$refs.mymap.clearNewMarker();
              this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
              this.cancelForm();
            } else {
              log.e(`# ERROR in saveDialog callback for degradation.modify call
            ERROR : ${errorMsg}
            val`, retval);
              this.showMessage(`ERREUR pendant la sauvegarde de cet objet !${errorMsg}`, 'error');
            }
          });
        } else {
          // SAVING NEW OBJECT
          log.l(`# in saveItem, NEW will save new objet ${this.editedIndex}`);
          // const that = this;
          const newItem = JSON.parse(JSON.stringify(item));
          const newDegradation = {
            title: newItem.properties.title,
            idcategorie: newItem.properties.idcategorie,
            isurgent: newItem.properties.isurgent,
            comment: newItem.properties.comment,
            creator: 0,
            x: newItem.properties.x,
            y: newItem.properties.y,
          };
          degradation.new(newDegradation, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in saveDialog callback for degradation.new call val', retval);
              // retval is the new index
              const newId = retval.lastInsertId;
              this.showMessage(
                `Merci pour votre annonce, celle-ci est en cours de traitement (id annonce ${newId})`,
                'success',
              );
              if (!this.isUserHavingLimitedCategories) {
                if (this.category_filter !== newItem.properties.idcategorie) {
                  // si l'utilisateur a un filtre actif different du nouvel objet
                  // on reset le filtre pour eviter qu'il ne comprennent
                  // pas pourquoi son objet ne s'affiche pas
                  this.category_filter = null;
                }
              }
              log.w(`# in saveDialog for new item id ${newId}`);
              // autant rafraichir les donnees depuis la BD
              this.getExistingCategories();
              this.$refs.mymap.clearNewMarker();
              // pas de item, mais newid pour ouvrir en edition
              // et permettre ajout photo
              this.handleEditItem(null, newId);
            } else {
              log.e(`# ERROR in saveDialog callback for degradation.newObjet call
            ERROR : ${errorMsg}
            retval`, retval);
              this.showMessage(`ERREUR pendant la sauvegarde de cet objet ! ${errorMsg}`, 'error');
            }
          });
        }
      } else {
        log.e('Received Item is null or undefined, nothing to save or Edit');
      }
    },
    toggleUserManager() {
      if (this.isUserManagerVisible) {
        this.isUserManagerVisible = false;
      } else if (this.isInEditMode && !this.formIsReadOnly) {
        // eslint-disable-next-line
        if (confirm('êtes-vous sûr de vouloir abandonner l\'édition qui en cours ?')) {
          this.cancelForm();
          this.sideBarMenuVisible = false;
          this.isUserManagerVisible = true;
        }
      } else {
        this.isUserManagerVisible = true;
        this.sideBarMenuVisible = false;
      }
    },
    setMapReady() {
      log.t('### Received MapReady event()');
      this.mapIsReady = true;
      if (this.mapNeedsLoadingData) {
        if (this.isListObjetRetrieved) {
          this.$refs.mymap.loadGeojsonPointsOfInterest(this.geojsonData);
          this.mapNeedsLoadingData = false;
        }
      }
    },
  }, // end of methods
  beforeDestroy() {
    log.t('# IN beforeDestroy()');
    clearInterval(this.autoLogoutTimer);
  },
};
</script>
